const QuotationStatus = require('../enums/quotation-status');

/**
* Quotation
*/

class Quotation {

    constructor(document) {
        const data = document.data()

        this.uid = document.id
        this.createdAt = data.createdAt ? data.createdAt : new Date()
        this.firstName = data.firstName
        this.lastName = data.lastName
        this.gender = data.gender
        this.phoneNumber = data.phoneNumber
        this.email = data.email
        this.comment = data.comment ? data.comment : ''
        this.address = {
            address: data.address.address,
            zipCode: data.address.zipCode,
            city: data.address.city,
            country: data.address.country
        }
        this.deliveries = data.deliveries
        this.freeTransport = data.freeTransport ? data.freeTransport : false;
        this.communicationType = data.communicationType
        this.amount = data.amount
        this.status = data.status ? data.status : QuotationStatus.TODO
        this.quotationID = data.quotationID
        this.ownerUID = data.ownerUID ? data.ownerUID : ''
        }

    get data() {
        return {
            uid: this.uid,
            createdAt: this.createdAt,
            firstName: this.firstName,
            lastName: this.lastName,
            gender: this.gender,
            phoneNumber: this.phoneNumber,
            email: this.email,
            freeTransport: this.freeTransport,
            address: {
                address: this.address.address,
                zipCode: this.address.zipCode,
                city: this.address.city,
                country: this.address.country,
            },
            deliveries: this.deliveries,
            communicationType: this.communicationType,
            amount: this.amount,
            status: this.status,
            quotationID: this.quotationID,
            comment: this.comment,
            ownerUID: this.ownerUID
        }
    }

    ID() {
        return this.quotationID
    }

    firebaseStoragePath() {
        return "quotations/Devis-" + this.ID() + ".pdf"
    }

}

export default Quotation;